import BranchInterface from '@/interfaces/BranchInterface';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import axios from 'axios';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';

class IoProductAPI {
  static getAllWithPrices(params: Record<string, unknown>): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.restAPIUrl}io-product`, {
        params: {
          endpoint: 'getAllWithPrices',
          ...params,
        },
      }).then((response) => {
        const products = [] as Product[];
        Object.values(response.data?.data?.products || {}).forEach((productAttributes) => {
          products.push(new Product(productAttributes as ProductInterface));
        });
        resolve(products);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getPriceExists(params: Record<string, unknown>): Promise<{
    postcode: boolean,
    street: boolean,
  }> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.restAPIUrl}io-product`, {
        params: {
          endpoint: 'getPriceExists',
          ...params,
        },
      }).then((response) => {
        resolve(response.data?.data);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getCategories(tree = false): Promise<ProductCategoryInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.restAPIUrl}io-product`, {
        params: {
          endpoint: 'getCategories',
          tree,
        },
      }).then((response) => {
        resolve(response.data?.data?.categories || []);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getBranches(): Promise<BranchInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.restAPIUrl}io-product`, {
        params: {
          endpoint: 'getBranches',
        },
      }).then((response) => {
        resolve(response.data?.data?.branches || []);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static validateCoupon(code: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      axios.get(`${window.ioappConfig.restAPIUrl}io-product`, {
        params: {
          endpoint: 'validateCoupon',
          code,
        },
      }).then((response) => {
        resolve(response?.data?.data?.valid || false);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default IoProductAPI;
